import { ALLOCATION_TYPE_METADATA } from '@/features/Collaborators/Models';
import {
    EXCLUDED_ALLOCATION_STATUSES,
    UNKNOWN_CLIENT_LABEL,
    UNKNOWN_COLLABORATOR_LABEL,
    UNKNOWN_PROJECT_LABEL,
    UNKNOWN_SCOPE_TYPE_LABEL,
} from '../exportsPage.definitions';
import type { AllocationExportItem, AllocationListRow } from '../exportsPage.types';

function label(value: string | null | undefined, fallback: string): string {
    return value?.trim() || fallback;
}

/**
 * Monta a listagem detalhada de alocações — uma linha por alocação.
 *
 * Diferente da agregação por cliente/mês, aqui entram todos os tipos de
 * alocação (inclusive Interno, Ausência, Comercial e Aviso Prévio). Só as
 * alocações canceladas ficam de fora, já que não representam alocação efetiva
 * e a planilha não tem coluna de status para distingui-las.
 *
 * Ordena por colaborador, data de início e cliente.
 */
export function buildAllocationListRows(items: AllocationExportItem[]): AllocationListRow[] {
    return items
        .filter((item) => !(item.status && EXCLUDED_ALLOCATION_STATUSES.includes(item.status)))
        .map((item) => ({
            collaboratorName: label(item.collaboratorName, UNKNOWN_COLLABORATOR_LABEL),
            clientName: label(item.clientName, UNKNOWN_CLIENT_LABEL),
            projectName: label(item.projectName, UNKNOWN_PROJECT_LABEL),
            scopeTypeLabel: item.allocationType
                ? ALLOCATION_TYPE_METADATA[item.allocationType]?.label ?? item.allocationType
                : UNKNOWN_SCOPE_TYPE_LABEL,
            startDate:
                item.startDate && !Number.isNaN(item.startDate.getTime()) ? item.startDate : null,
            endDate: item.endDate && !Number.isNaN(item.endDate.getTime()) ? item.endDate : null,
        }))
        .sort(
            (a, b) =>
                a.collaboratorName.localeCompare(b.collaboratorName, 'pt-BR') ||
                compareDates(a.startDate, b.startDate) ||
                a.clientName.localeCompare(b.clientName, 'pt-BR')
        );
}

/** Ordena datas em ordem crescente, jogando as vazias para o fim. */
function compareDates(a: Date | null, b: Date | null): number {
    if (a && b) {
        return a.getTime() - b.getTime();
    }
    if (a) {
        return -1;
    }
    if (b) {
        return 1;
    }
    return 0;
}
